import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { type ConfirmAwardedLaneAction } from '../domain/ConfirmAwardedLaneAction'
import { ProposalRepository } from '../infra/ProposalRepository'

export type ConfirmAwardedLanesFactoryDependencies = {
  repository: ProposalRepository
}

export type ConfirmAwardedLanesParams = {
  rfpId: string
  laneProposalIds: Array<number>
  action: ConfirmAwardedLaneAction
}

export function confirmAwardedLanesFactory({ repository }: ConfirmAwardedLanesFactoryDependencies) {
  return async function confirmAwardedLanesImpl(
    params: ConfirmAwardedLanesParams,
    config?: AbortController
  ) {
    return repository.updateAwardedLanes(params, config)
  }
}

export function confirmAwardedLanes(params: ConfirmAwardedLanesParams, config?: AbortController) {
  const httpClient = new ShipperGuideClient()
  const repository = new ProposalRepository({ httpClient })
  const updateLanes = confirmAwardedLanesFactory({ repository })
  return updateLanes(params, config)
}
